import { DestroyRef } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

import {
  ScreenAnalyticsProps,
  TemplateConfigInterface,
  emitScreenAnalytics,
  screenAnalyticsOnDisplay$,
} from '@flowx/core-sdk'

/**
 * Emits the SCREEN event on display — the readiness barrier, the onLoad completion wait and
 * the navigation / modal-dismiss re-displays the onDisplay actions run under.
 *
 * <p>Angular twin of React's `useScreenAnalytics`; the rules live in core so the two
 * renderers cannot drift.
 */
export const emitScreenAnalyticsOnDisplay = (
  config: TemplateConfigInterface,
  flowxProps: ScreenAnalyticsProps | undefined,
  destroyRef: DestroyRef
): void => {
  screenAnalyticsOnDisplay$(config)
    .pipe(takeUntilDestroyed(destroyRef))
    .subscribe(() => emitScreenAnalytics(config, flowxProps))
}
